import React, { ReactNode } from 'react';

import './spec-course-lesson-view__header.scss';

interface Props {
    children: ReactNode | ReactNode[];
}

export const SpecCourseLessonViewHeader = ({ children }: Props) => {
    return <div className="spec-course-lesson-view__header">{children}</div>;
};
